let nav = document.getElementById('anchor-list'),
    position = 1;

export default function spawnNavItem(a) {
  var node = document.createElement('LI'),
      link = document.createElement('A'),
      title = document.createTextNode(a.dataset.anchorTitle),
      href = '#' + a.id,
      anchorId = a.id;

  link.href = href;
  link.appendChild(title);
  node.appendChild(link);
  node.setAttribute('data-anchor-id', anchorId);
  node.classList = 'animate__animated animate__fadeIn animate transition';
  node.style = 'animation-delay: ' + (position * 500 + 1500) + 'ms';
  nav.appendChild(node);
  position++;
}



// WEBPACK FOOTER //
// ./scripts/components/navSpawn.js